import PropTypes from 'prop-types';
import styles from "./checkDetail.module.scss"
import cn from "classnames";

const Discount = ({ data, currency, seat, isExpanded }) => {
    const { name, price } = data || {};
    return (
        <div className={cn("row mx-0 col-12 py-1 px-0 ", isExpanded ? styles.checkItemsFontExpanded : styles.CheckItemsFont)}>
            <div className={cn(isExpanded ? styles.serialNumExtend : styles.serialNum, 'mr-1')}>{seat}</div>
            <div className={cn("col-8 pl-2 pr-0", isExpanded && 'd-flex align-items-center')}>{name}</div>
            <div className={cn("col-3 px-0 text-right", isExpanded && 'd-flex align-items-center justify-content-end')}>{`${currency}${price.toFixed(2)}`}</div>
        </div>
    )
};

Discount.propTypes = {
  data: PropTypes.object.isRequired,
  currency: PropTypes.string.isRequired,
  seat: PropTypes.object.isRequired,
  isExpanded: PropTypes.bool,
};
export default Discount;